import { ko as ko$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by Park Seok Ho

var ko = {
  language: 'ko',
  country: 'kr',
  name: '한국어',
  embeddedLocale: merge(error, login),
  flags: ['KR'],
  dateFns: ko$1,
  format: {
    date: 'yyyy.MM.dd',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { ko as default };
